// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared shimmer placeholders. Uses existing tokens; respects reduced motion. */

.ui-skeleton {
  display: block;
  position: relative;
  overflow: hidden;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
}

.ui-skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent 0,
    rgba(255, 255, 255, 0.35) 50%,
    transparent 100%
  );
  animation: ui-skeleton-shimmer 1.4s ease-in-out infinite;
}

[data-theme='dark'] .ui-skeleton::after {
  background: linear-gradient(
    90deg,
    transparent 0,
    rgba(255, 255, 255, 0.08) 50%,
    transparent 100%
  );
}

@keyframes ui-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* Variant shapes */
.ui-skeleton--text {
  height: 14px;
  border-radius: var(--radius-sm);
}

.ui-skeleton--line {
  height: 10px;
  border-radius: var(--radius-sm);
}

.ui-skeleton--card {
  height: 120px;
  border-radius: var(--radius-lg);
}

.ui-skeleton--table-row {
  height: 44px;
  border-radius: var(--radius-sm);
}

/* Stacked group spacing (count > 1) */
.ui-skeleton-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ui-skeleton-group > .ui-skeleton:last-child {
  width: 70%;
}

/* Table skeleton helper */
.ui-table-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 0;
}

.ui-table-skeleton__row {
  display: grid;
  gap: 16px;
  align-items: center;
}

@media (prefers-reduced-motion: reduce) {
  .ui-skeleton::after {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Skeleton.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B;;;;;GAKC;EACD,wDAAwD;AAC1D;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Shared shimmer placeholders. Uses existing tokens; respects reduced motion. */\n\n.ui-skeleton {\n  display: block;\n  position: relative;\n  overflow: hidden;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n}\n\n.ui-skeleton::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    transparent 0,\n    rgba(255, 255, 255, 0.35) 50%,\n    transparent 100%\n  );\n  animation: ui-skeleton-shimmer 1.4s ease-in-out infinite;\n}\n\n[data-theme='dark'] .ui-skeleton::after {\n  background: linear-gradient(\n    90deg,\n    transparent 0,\n    rgba(255, 255, 255, 0.08) 50%,\n    transparent 100%\n  );\n}\n\n@keyframes ui-skeleton-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Variant shapes */\n.ui-skeleton--text {\n  height: 14px;\n  border-radius: var(--radius-sm);\n}\n\n.ui-skeleton--line {\n  height: 10px;\n  border-radius: var(--radius-sm);\n}\n\n.ui-skeleton--card {\n  height: 120px;\n  border-radius: var(--radius-lg);\n}\n\n.ui-skeleton--table-row {\n  height: 44px;\n  border-radius: var(--radius-sm);\n}\n\n/* Stacked group spacing (count > 1) */\n.ui-skeleton-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ui-skeleton-group > .ui-skeleton:last-child {\n  width: 70%;\n}\n\n/* Table skeleton helper */\n.ui-table-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 0;\n}\n\n.ui-table-skeleton__row {\n  display: grid;\n  gap: 16px;\n  align-items: center;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ui-skeleton::after {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
